import React from 'react';

import { IClassNames, makeClassNames } from '../../../utils/styles';

import './hr.scss';

const classNames = (): IClassNames =>
  makeClassNames({
    hr: 'hr',
  });

const cn = classNames();

const Hr: React.FC = () => <hr className={cn.hr} />;

export default Hr;
